// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: #efefef;
}

.error-container {
  background: #ed143d;
  color: white;
  padding: 10px;
  font-size: 14px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 5px 10px 12% 10px;
  min-height: 90vh;
}
.body .meeting-time {
  background: #fff;
  border-radius: 12px;
  padding: 5px 10px;
  gap: 5px;
  display: flex;
  flex-direction: column;
}
.body .meeting-time > *:not(:last-child) {
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}
.body .meeting-time .all-day, .body .meeting-time .working-hours {
  padding-block: 5px 10px;
}
.body .meeting-time .all-day ion-toggle, .body .meeting-time .working-hours ion-toggle {
  font-weight: 600;
  --track-background-checked: #ed143d;
}
.body .meeting-time .start-time div, .body .meeting-time .end-time div {
  display: flex;
  align-items: center;
  justify-content: end;
}
.body .meeting-time .start-time div span, .body .meeting-time .end-time div span {
  font-weight: 600;
  flex: 0.3;
  margin-right: auto;
  padding: 0;
}
.body .meeting-time .start-time div ion-chip, .body .meeting-time .end-time div ion-chip {
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}
.body .repeat-meeting {
  background: #fff;
  border-radius: 12px;
  padding-inline: 10px;
  padding-bottom: 5px;
  display: flex;
  font-weight: 600;
  flex-direction: column;
}
.body .repeat-meeting > *:not(:last-child) {
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}
.body .repeat-meeting ion-item {
  border-radius: 6px;
  --padding-start: 0;
  --inner-padding-end:0;
}
.body .repeat-meeting ion-item ion-icon {
  font-size: 28px;
}
.body .repeat-meeting ion-item ion-label {
  margin-left: 5px;
  font-weight: 600;
  margin: 0;
  color: #888;
}
.body .repeat-meeting .weekdays-container {
  display: flex;
  max-width: -webkit-fit-content;
  max-width: fit-content;
  margin: 0 auto;
  gap: 5px;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-block: 10px 5px;
}
.body .repeat-meeting .weekdays-container ion-badge {
  border-radius: 12px;
  background: none;
  color: #333;
  border: 1px solid #333;
  padding: 8px 15px;
  flex-wrap: wrap;
}
.body .repeat-meeting .weekdays-container ion-badge.selected {
  background: #ed143d;
  color: white;
  border: 1px solid #ed143d;
}
.body .repeat-meeting .recurrence-end {
  display: flex;
  align-items: center;
  padding-top: 5px;
  justify-content: space-between;
}
.body .repeat-meeting .recurrence-end span {
  font-weight: 600;
  margin: 0;
  padding: 0;
}
.body .repeat-meeting .recurrence-end ion-chip {
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}
.body .reset-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: 10px;
  color: #ed143d;
}

ion-chip.selected {
  color: #ed143d;
}

.footer {
  display: flex;
  gap: 5px;
}
.footer ion-button {
  flex: 1;
  font-size: 14px;
  border-radius: 6px;
  font-weight: 600;
  --padding-top: 8px;
  --padding-bottom: 8px;
}
.footer ion-button:last-child {
  --background: var(--ion-color-primary);
}

ion-datetime {
  --ion-color-primary: #ed143d;
  box-shadow: none;
  margin-top: 10px;
  margin-inline: auto;
}

ion-datetime::part(calendar-day):focus {
  box-shadow: none;
}

ion-datetime.datetime-calendar {
  display: none !important;
}

ion-datetime::part(month-year-button) {
  color: #ed143d;
  padding-block: 0;
  transform: translateY(-8px);
}

ion-select::part(label) {
  font-size: 16px;
}

ion-select::part(container) {
  color: #ed143d;
}

ion-select::part(icon) {
  color: #ed143d;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/search/searchpopover/searchpopover.component.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF;;AAGA;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAAJ;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;AAAJ;AACI;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;AACR;AAAQ;EACI,6BAAA;EACA,mBAAA;AAEZ;AAAQ;EACI,uBAAA;AAEZ;AADY;EACA,gBAAA;EACA,mCAAA;AAGZ;AACQ;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AACV;AAAU;EACE,gBAAA;EACA,SAAA;EAEA,kBAAA;EACA,UAAA;AACZ;AACU;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;AACZ;AAMI;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EAEA,sBAAA;AALR;AAMQ;EACI,6BAAA;EACA,mBAAA;AAJZ;AAMM;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AAJR;AAKQ;EACE,eAAA;AAHV;AAKQ;EACE,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAHV;AAMM;EACE,aAAA;EACA,8BAAA;EAAA,sBAAA;EACA,cAAA;EACA,QAAA;EACA,OAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,uBAAA;AAJR;AAKQ;EAEI,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;AAJZ;AAKU;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAHZ;AAOM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AALR;AAMQ;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAJV;AAMQ;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;AAJV;AAUI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AARN;;AAYE;EACE,cAAA;AATJ;;AAWE;EACE,aAAA;EACA,QAAA;AARJ;AASI;EACE,OAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAPN;AAQM;EACE,sCAAA;AANR;;AAWE;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AARJ;;AAWE;EACE,gBAAA;AARJ;;AAaE;EAEE,wBAAA;AAXJ;;AAcE;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;AAXJ;;AAgBE;EAEE,eAAA;AAdJ;;AAiBE;EAEE,cAAA;AAfJ;;AAkBE;EACE,cAAA;AAfJ","sourcesContent":["\nion-content {\n  --background: #efefef;\n}\n\n.error-container {\n    background: #ed143d;\n    color: white;\n    padding: 10px;\n    font-size: 14px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n  }\n  \n  .body {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n    padding: 5px 10px 12% 10px;\n    min-height: 90vh;\n    .meeting-time {\n        background: #fff;\n        border-radius: 12px;\n        padding:5px 10px;\n        gap: 5px;\n        display: flex;\n        flex-direction: column;\n        > *:not(:last-child) {\n            border-bottom: 1px solid #eee;  \n            padding-bottom: 5px;  \n        }\n        .all-day, .working-hours {\n            padding-block:5px 10px;\n            ion-toggle {\n            font-weight: 600;\n            --track-background-checked: #ed143d;\n            }\n        }\n        .start-time, .end-time {\n        div {\n          display: flex;\n          align-items: center;\n          justify-content: end;\n          span {\n            font-weight: 600;\n            flex: 0.3;\n            // color: #888;\n            margin-right: auto;\n            padding: 0;\n          }\n          ion-chip {\n            border-radius: 12px;\n            font-weight: 700;\n            letter-spacing: 1.2px;\n           \n          }\n        }\n      }\n    \n    }\n    .repeat-meeting {\n        background: #fff;\n        border-radius: 12px;\n        padding-inline: 10px;\n        padding-bottom: 5px;\n        display: flex;\n        font-weight: 600;\n\n        flex-direction: column;\n        > *:not(:last-child) {\n            border-bottom: 1px solid #eee;  \n            padding-bottom: 5px;  \n        }\n      ion-item {\n        border-radius: 6px;\n        --padding-start: 0;\n        --inner-padding-end:0;\n        ion-icon {\n          font-size: 28px;\n        }\n        ion-label {\n          margin-left: 5px;\n          font-weight: 600;\n          margin: 0;\n          color: #888;\n        }\n      }\n      .weekdays-container {\n        display: flex;\n        max-width: fit-content;\n        margin:0 auto;\n        gap: 5px;\n        flex: 1;\n        align-items: center;\n        justify-content: flex-start;\n        flex-wrap: wrap;\n        padding-block:10px 5px;\n        ion-badge {\n            // flex: 0 0 calc(25% - 5px);\n            border-radius: 12px; \n            background: none;\n            color: #333;\n            border: 1px solid #333;\n            padding: 8px 15px;\n            flex-wrap:wrap;\n          &.selected {\n            background: #ed143d;\n            color: white;\n            border: 1px solid #ed143d;\n          }\n        }\n      }\n      .recurrence-end {\n        display: flex;\n        align-items: center;\n        padding-top: 5px;\n        justify-content: space-between;\n        span {\n          font-weight: 600;\n          margin: 0;\n          padding: 0;\n        }\n        ion-chip {\n          border-radius: 12px;\n          font-weight: 700;\n          letter-spacing: 1.2px;\n         \n        }\n      }\n      \n    }\n    .reset-button-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding-block: 10px;\n      color: #ed143d;\n    }\n  }\n\n  ion-chip.selected {\n    color: #ed143d;\n  }\n  .footer {\n    display: flex;\n    gap: 5px;\n    ion-button {\n      flex: 1;\n      font-size: 14px;\n      border-radius: 6px;\n      font-weight: 600;\n      --padding-top: 8px;\n      --padding-bottom: 8px;\n      &:last-child {\n        --background: var(--ion-color-primary);\n      }\n    }\n  }\n  \n  ion-datetime {\n    --ion-color-primary: #ed143d;\n    box-shadow: none;\n    margin-top: 10px;\n    margin-inline: auto;\n  }\n  \n  ion-datetime::part(calendar-day):focus {\n    box-shadow: none;\n  }\n  \n  \n  \n  ion-datetime.datetime-calendar {\n    // color: #ed143d;\n    display: none !important;\n  }\n  \n  ion-datetime::part(month-year-button) {\n    color: #ed143d;\n    padding-block: 0;\n    transform: translateY(-8px);\n  }\n  \n \n  \n  ion-select::part(label) {\n    // color: #888;\n    font-size: 16px;\n  }\n  \n  ion-select::part(container) {\n    // font-size: 15px;\n    color: #ed143d;\n  }\n  \n  ion-select::part(icon) {\n    color: #ed143d;\n    // font-size: 20px;\n    // transform: translateY(11px);\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
